// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgo_a","AdSlotBranding__desktop":"bgo_b","AdSlotBranding__mobile":"bgo_c"};